import { kymw1400Handlers } from "./kymw1400-handlers";
import { kymw1404Handlers } from "./kymw1404-handlers";
import { kymw1406Handlers } from "./kymw1406-handlers";
import { kymw1422Handlers } from "./kymw1422-handlers";

export const kymw14Handlers = [
  ...kymw1400Handlers,
  ...kymw1404Handlers,
  ...kymw1406Handlers,
  ...kymw1422Handlers
];